module.exports = __webpack_public_path__ + "static/img/James.Hird.eec0ec0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/James.Hird.jpg
// module id = gzpI
// module chunks = 0